import { render, staticRenderFns } from "./dialogForm1.vue?vue&type=template&id=07c3a50c&scoped=true"
import script from "./dialogForm1.vue?vue&type=script&lang=js"
export * from "./dialogForm1.vue?vue&type=script&lang=js"
import style0 from "./dialogForm1.vue?vue&type=style&index=0&id=07c3a50c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3a50c",
  null
  
)

export default component.exports